import { RewardType } from 'root/src/shared/rewards/constants';
function getRewardTypeBaseName(rewardType, suffix) {
    switch (rewardType) {
        case RewardType.KEY:
            return `key${suffix}`;
        case RewardType.CODE:
            return `code${suffix}`;
        case RewardType.BUNDLE:
            return `bundle${suffix}`;
        case RewardType.CUSTOM:
            return `asset${suffix}`;
        default:
            return `reward${suffix}`;
    }
}
export function getRewardTypeName(rewardType, options) {
    const { amount = 1, capitalize = false } = options;
    const suffix = amount > 1 ? 's' : '';
    const name = getRewardTypeBaseName(rewardType, suffix);
    if (capitalize) {
        return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return name;
}
